import { useMerchantDeviceStore } from '@/stores/modules/merchant-device'
import { getMerchantDeviceSn, setMerchantDeviceSn } from '@/utils/merchant-device'
import api from '@/api'

export function useMerchantDeviceBinding() {
  const merchantDeviceStore = useMerchantDeviceStore()
  let merchantDeviceSn = ref(getMerchantDeviceSn())
  if (!merchantDeviceSn.value) {
    merchantDeviceSn.value = window.electron?.macAddress || generateRandomMAC() // 读取electron中暴露的mac地址，兼容读取不到的情况，随机生成
    setMerchantDeviceSn(merchantDeviceSn.value)
  }

  /**
   * 判断设备是否绑定门店
   * @returns {Promise<void>}
   */
  async function checkIsBinding() {
    if (merchantDeviceStore.isBinding) {
      return true
    }
    try {
      const { data } = await api.merchantDevice.getBindingStatus()
      if (data.binding_status) {
        merchantDeviceStore.isBinding = true // 全局记录已绑定
      }
      return data.binding_status
    } catch (e) {
      console.error('判断设备是否绑定门店失败', e)
    }
  }

  /**
   * 生成随机MAC地址格式的数据
   * @returns {string}
   */
  function generateRandomMAC() {
    let macAddress = ''

    for (let i = 0; i < 6; i++) {
      // 生成一个0到255之间的随机数
      const randomByte = Math.floor(Math.random() * 256)

      // 将随机数格式化为两位十六进制数，并添加到MAC地址
      macAddress += ('0' + randomByte.toString(16)).slice(-2).toUpperCase()

      // 在每两位十六进制数后添加冒号，最后一组数字后不添加
      if (i !== 5) {
        macAddress += ':'
      }
    }

    return macAddress
  }
  return {
    merchantDeviceSn,
    checkIsBinding
  }
}
